import { message as Message } from 'antd';

Message.config({
  top: 64,
  duration: 2,
});

/** @function */
export default Message;
